import { useCreateOrUpdateMultipleprintInExhibition } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { MultipleprintInExhibition } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const MultipleprintInExhibitionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: MultipleprintInExhibition;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    expositionsDansEstampesMultiplesDescriptionNumero: z.string(),
    expositionsDansEstampesMultiplesDescriptionExemplaireExpose: z.string(),
    exhibition: z.object({
      expositionsDescriptionNumeroExpo: z.string(),
      expositionsDescriptionResume: z.string(),
    }),
  });

  const { mutate: createOrUpdateMultipleprintInExhibition } =
    useCreateOrUpdateMultipleprintInExhibition(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      exhibition: data.exhibition,
      expositionsDansEstampesMultiplesDescriptionNumero:
        data.expositionsDansEstampesMultiplesDescriptionNumero,
      expositionsDansEstampesMultiplesDescriptionExemplaireExpose:
        data.expositionsDansEstampesMultiplesDescriptionExemplaireExpose,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateMultipleprintInExhibition({
      id: data.id,
      multipleprintId: data.multipleprint.id,
      exhibitionId: data.exhibition.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default MultipleprintInExhibitionDrawer;
